import { RootState } from "@/store/store";
import { ModuleTree } from "vuex";
import { screeningActions } from "./screening.actions";
import { screeningState } from "./screening.state";
import { screeningMutations } from "./screening.mutations";

export default {
    namespaced: true,
    state: screeningState,
    actions: screeningActions,
    mutations: screeningMutations,
} as unknown as ModuleTree<RootState>;